import { render, staticRenderFns } from "./DynamicPageTemplate.vue?vue&type=template&id=1792061e&"
import script from "./DynamicPageTemplate.vue?vue&type=script&lang=js&"
export * from "./DynamicPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports